import EventLayout from "components/Layout/EventLayout";
import { lang } from "constant/lang";
import useAuth from "hooks/useAuth";
import React, { useState, useEffect } from "react";
import stars2 from "images/pattern/stars-2.svg";
import star from "images/pattern/star.svg";
import actionApi from "services/actionApi";

const SeminarPage = () => {
  const event = lang.events.seminar;
  const { isAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isJoin, setIsJoin] = useState(false);

  useEffect(() => {
    if (!isAuth) {
      return;
    }
    actionApi
      .seminarCheck()
      .then((response) => {
        const isJoin = response?.data?.is_join_seminar;
        setIsJoin(isJoin);
      })
      .catch()
      .finally(() => {
        setIsLoading(false);
      });
  }, [isAuth]);

  return (
    <EventLayout
      event={event}
      isLoading={isLoading}
      isAuth={isAuth}
      isJoin={isJoin}
      isClosed={true}
      isBig={true}
    >
      <div
        className="mt-16 mb-2 sm:mt-32 sm:mb-10 items-center font-yesevaOne text-wce-navy w-fit
          text-2xl sm:text-4xl md2:text-6.5xl min-h-[48px] sm:min-h-[80px]"
      >
        Rundown & Sessions
      </div>
      <div className="flex flex-col sm:flex-row items-center w-full gap-10 sm:gap-20">
        <SessionCard />
        <RundownCard />
      </div>
      <div
        className="mt-10 mb-5 sm:mt-20 sm:mb-10 items-center font-yesevaOne text-wce-navy w-fit mx-auto
          text-2xl sm:text-4xl md2:text-6.5xl min-h-[48px] sm:min-h-[80px]"
      >
        How to Get Here
      </div>
      <LocationCard />
    </EventLayout>
  );
};

const LocationCard = () => (
  <>
    <div className="relative p-4 border border-wce-pink rounded-2xl w-fit mx-auto">
      <div className="absolute -translate-x-full left-6 -top-6">
        <img className="w-[60px] min-w-[60px]" src={stars2} alt={"stars2"} />
      </div>
      <div className="absolute translate-x-full right-4 -bottom-4">
        <img className="w-[24px] min-w-[24px]" src={star} alt={"star"} />
      </div>
      <div className="font-yesevaOne text-wce-pink-bright text-2xl font-medium">
        {lang.events.seminar.location}
      </div>
    </div>
    <div className="mt-10 mb-6 text-wce-neutral-9 text-lg">
      {lang.seminar.locations.desc}
    </div>
    <div className="flex flex-col sm:flex-row gap-8">
      {lang.seminar.locations.route.map((l) => (
        <div
          className="flex flex-col bg-white rounded-2xl border-2 border-white
            p-8 shadow-wce-hard relative text-wce-neutral-9 gap-4 w-full"
        >
          <div className="text-3xl font-medium mx-auto">{l.title}</div>
          <div className="text-lg text-center">{l.desc}</div>
        </div>
      ))}
    </div>
  </>
);
const RundownCard = () => (
  <div className="flex flex-col gap-2">
    {lang.seminar.rundown.map((r) => (
      <div className="flex gap-2">
        <div className="font-yesevaOne text-wce-pink-bright text-xl w-[70px]">
          {r?.time}
        </div>
        <div className="text-wce-navy w-full">{r?.title}</div>
      </div>
    ))}
  </div>
);

const SessionCard = () => (
  <div
    className="flex flex-col bg-white rounded-2xl border-2 border-white
      p-8 shadow-wce-hard relative text-wce-neutral-8 gap-4"
  >
    {lang.seminar.sessions.map((s, id) => (
      <div
        className={`flex flex-col sm:flex-row gap-6 ${
          id < 2 && "pb-4 border-b-2 border-wce-yellow"
        }`}
      >
        <div className="w-full sm:w-2/5">
          <div className="font-yesevaOne text-wce-pink-bright text-xl">
            Session {id + 1}
          </div>
          <div className="mt-2 font-bold text-wce-neutral-9">{s.title}</div>
        </div>
        <div className="flex flex-col gap-2">
          {s.speakers.map((sp) => (
            <div className="flex items-center gap-6">
              <div className="">
                <img
                  src={sp.image}
                  alt="speaker"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                    borderRadius: "100%",
                    height: "auto",
                    width: "72px",
                  }}
                />
              </div>
              <div className="text-wce-neutral-9">
                <div className="mb-1 font-medium">{sp.name}</div>
                <div>{sp.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SeminarPage;
